import { render } from "./LearnWhyTitle.vue?vue&type=template&id=2eee447a&scoped=true"
import script from "./LearnWhyTitle.vue?vue&type=script&lang=js"
export * from "./LearnWhyTitle.vue?vue&type=script&lang=js"

import "./LearnWhyTitle.vue?vue&type=style&index=0&id=2eee447a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eee447a"]])

export default __exports__